import { useMediaQuery } from '@aloft/toolkit-sui/chakra';

const BREAKPOINTS = {
  mobileMax: 550,
  tabletMax: 1100,
  laptopMax: 1500,
};

const QUERIES = {
  mobileAndBelow: `(max-width: ${BREAKPOINTS.mobileMax}px)`,
  tabletAndBelow: `(max-width: ${BREAKPOINTS.tabletMax}px)`,
  laptopAndBelow: `(max-width: ${BREAKPOINTS.laptopMax}px)`,
};

export function useBreakpoints() {
  const [isMobileAndBelow, isTabletAndBelow, isLaptopAndBelow] = useMediaQuery([
    QUERIES.mobileAndBelow,
    QUERIES.tabletAndBelow,
    QUERIES.laptopAndBelow,
  ]);

  return {
    isMobileAndBelow: isMobileAndBelow ?? false,
    isTabletAndBelow: isTabletAndBelow ?? false,
    isLaptopAndBelow: isLaptopAndBelow ?? false,
  };
}
